import * as React from 'react';
import { withDataFetch } from '../hoc/withDataFetch';

const Line = React.lazy(() =>
  import('react-chartjs-2').then(module => ({ default: module.Line }))
);

export default withDataFetch(Line);
